// import { IS_PROD } from "@lib/utils/getEnvVariable";

// // Access token: prod 60 minutes, dev 2 minutes (seconds for JWT exp)
// export const ACCESS_TOKEN_EXPIRES_IN_SECONDS = IS_PROD ? (2 * 1_800) : 120;
// // Access token: prod 60 minutes, dev 2 minutes (milliseconds for cookie expiry)
// export const ACCESS_TOKEN_EXPIRES_IN_MS = IS_PROD ? (2 * 1_800_000) : 120_000;

// // Refresh token: prod 360 days, dev 2 hours (seconds for JWT exp)
// export const REFRESH_TOKEN_EXPIRES_IN_SECONDS = IS_PROD ? (12 * 2_592_000) : 7_200;
// // Refresh token: prod 360 days, dev 2 hours (milliseconds for cookie expiry and DB)
// export const REFRESH_TOKEN_EXPIRES_IN_MS = IS_PROD ? (12 * 2_592_000_000) : 7_200_000;



// Access token: prod 60 minutes
export const ACCESS_TOKEN_EXPIRES_IN_SECONDS = (2 * 1_800);
// Access token: prod 60 minutes
export const ACCESS_TOKEN_EXPIRES_IN_MS = (2 * 1_800_000);

// Refresh token: prod 360 days
export const REFRESH_TOKEN_EXPIRES_IN_SECONDS = (12 * 2_592_000);
// Refresh token: prod 360 days
export const REFRESH_TOKEN_EXPIRES_IN_MS = (12 * 2_592_000_000);



export const GOOGLE_OAUTH_COOKIE_NAME = `google_oauth_token`;
export const OTP_COOKIE_NAME = "otp_token";
export const PHONE_OTP_COOKIE_NAME = "phone_otp_token";
export const PHONE_OTP_COOKIE_NAME_AFTER_REGISTER = "phone_otp_token_after_register";
export const OTP_COOKIE_NAME_AFTER_REGISTER = "otp_token_after_register";
export const WEBAUTHN_CHALLENGE_COOKIE_NAME = "webauthn_challenge_token";

/** No valid session — missing/expired/rejected access token. Client may refresh once and retry. */
export const NOT_AUTHENTICATED = "NOT_AUTHENTICATED" as const;

export const isNotAuthenticatedErrorCode = (code: string | undefined): boolean =>
    code === NOT_AUTHENTICATED;

/** Sensitive settings (password/name/passkey) only within this window after session loggedInAt. */
export const FRESH_SESSION_MAX_AGE_MS = 300_000; // 5 * 60 * 1000;

export const FRESH_SESSION_REQUIRED = "FRESH_SESSION_REQUIRED" as const;

export const isFreshSessionLoggedInAt = (
    loggedInAt: number | null | undefined,
    now = Date.now(),
): boolean => {
    if (loggedInAt == null) return false;
    return now - loggedInAt <= FRESH_SESSION_MAX_AGE_MS;
};

// ============ PKCE Auth Code Constants ============
// Auth code: 1 minute in milliseconds (short-lived, one-time use)
export const AUTH_CODE_EXPIRES_IN_MS = 60_000; // 1000 * 60 * 1

/** Phone-user claim-email OTP JWT TTL (seconds). */
export const CLAIM_EMAIL_OTP_EXPIRES_IN_SECONDS = 600; // 10 min

/** Change-email OTP JWT TTL (seconds). */
export const CHANGE_EMAIL_OTP_EXPIRES_IN_SECONDS = 600; // 10 min